<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      :footer="false"
      size="normal"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText">
    <template #header>
      <span>导入品类</span>
    </template>
    <template #content>
      <gj-upload
          class="upload-btn"
          :template-url="'/supply/category/downloadTemplate'"
          container-type="category"
          @uploadAfter="uploadAfter">
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '模板中的表头不可更改，不能删除',
            '同一个品类名称存在多条记录，以第一条记录为准'
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "../../../../../minxins";
  import {importCategory} from "../../../../../api/product";

  export default {
    name: "app-product-category-import-modal",
    mixins: [modalMixIn, uploadMixin],
    data() {
      return {}
    },
    methods: {
      destroy() {
        this.$gjModal.$gjDestroy();
      },
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importCategory(attId)
          .then((res) => {
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      }
    }
  }
</script>

<style scoped>
  .upload-btn {
    margin: 0 0 15px;
  }
</style>
